/**
 * Impressum nach § 5 DDG (früher § 5 TMG). Muss von jeder Seite erreichbar und
 * als solches erkennbar sein, deshalb eine eigene Route und ein Fußzeilen-Link.
 */
import { Link } from 'react-router'

export function ImpressumSeite() {
  return (
    <div className="recht-seite">
      <div className="recht-spalte">
        <Link to="/" className="verweis zurueck">
          Zurück
        </Link>

        <h1>Impressum</h1>

        <h2>Anbieter</h2>
        <p>
          H&amp;K Automation GbR, tritt auch als H&amp;K KI Solutions auf.
          <br />
          Obere Burghalde 92, 71229 Leonberg
        </p>

        <h2>Vertretungsberechtigte Gesellschafter</h2>
        <p>Louis Honal und Sven Konstantinow</p>

        <h2>Kontakt</h2>
        <p>
          E-Mail: louis.honal@hks-automation.de
        </p>

        <h2>Verantwortlich für den Inhalt</h2>
        <p>Louis Honal, Anschrift wie oben</p>

        <h2>Umsatzsteuer-Identifikationsnummer</h2>
        <p>DE460966454</p>

        <p className="leiser">
          Die Gesellschaft ist nicht im Handels- oder Gesellschaftsregister eingetragen.
        </p>

        <Link to="/" className="verweis zurueck">
          Zurück
        </Link>
      </div>
    </div>
  )
}
